import { createSlice } from "@reduxjs/toolkit";
import { getAvtar, getCountry, setupProfile, uploadPhoto } from "../thunks/registerThunks";

const initialState = {
  step: 1,
  loading: false,
  email: "",
  user_id: null,
  token: null,
  error: null,
  avatars: [],
  countries: [],
  avtarID : null,
};

const profilesetSlice = createSlice({
  name: "setupProfile",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* Get avtar */
      .addCase(getAvtar.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAvtar.fulfilled, (state, action) => {
        state.loading = false;
        state.avatars = action.payload.data;  
      })

      .addCase(getAvtar.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* Get Country */
      .addCase(getCountry.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCountry.fulfilled, (state, action) => {
        state.loading = false;
        state.countries = action.payload.data;
      })
      .addCase(getCountry.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* setProfile */
      .addCase(setupProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(setupProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.action = action.payload.data;
      })
      .addCase(setupProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(uploadPhoto.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadPhoto.fulfilled, (state, action) => {
        state.loading = false;
        state.action = action.payload.data;
      })
      .addCase(uploadPhoto.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {} = profilesetSlice.actions;
export default profilesetSlice.reducer;
